import { encodeString } from '../../../../../core/util/browser_util';

export class SuggestionView {
  static createSuggestWordArea(suggestWordList: string[]): string {
    const suggestWordArea: string = this.createSuggestWord(suggestWordList);
    return `<p class="a-text -medium u-mb-16 u-text-bold">もしかして、
      ${suggestWordArea}ではありませんか？
  </p>
  `;
  }

  static createSuggestWord(suggestWordList: string[]): string {
    let resultHtml = '';
    suggestWordList.forEach((suggestWord, index) => {
      const url = this.createUrl(suggestWord);
      resultHtml += `
      <a href="${url}" class="a-textlink">${suggestWord}</a>`;
      if (index !== suggestWordList.length - 1) {
        resultHtml += `、または`;
      }
    });
    return resultHtml;
  }

  static createUrl(word: string): string {
    return `?searchWord=${encodeString(word)}&fromSelfPage=0`;
  }

}
